module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/default/default.layout.component.scss
// module id = ./src/app/layout/default/default.layout.component.scss
// module chunks = main